import { getCurrentDomainExtension } from './url.mjs';

let webToolsReadyPromise;
const webtoolsScriptId = 'babbel-webtools';

function getScriptStatus(scriptTag, globalVariableName) {
  return {
    [`is_${globalVariableName}_available`]: globalThis[globalVariableName] !== undefined,
    exists: Boolean(scriptTag),
    src: scriptTag?.getAttribute('src'),
  };
}

function getScriptStatuses() {
  const gtmScriptTag = document.querySelector(`script[src^="https://www.googletagmanager.com"]`);
  const marketingTrackerScriptTag = document.querySelector(
    `script[src^="https://marketing-tracker.babbel"]`,
  );
  const webToolsScriptTag = document.querySelector(`#${webtoolsScriptId}`);
  return {
    gtmScript: getScriptStatus(gtmScriptTag, 'gtm'),
    marketingTrackerScript: getScriptStatus(marketingTrackerScriptTag, 'MarketingTracker'),
    webToolsScript: getScriptStatus(webToolsScriptTag, 'webTools'),
  };
}

function loadWebToolsModuleIfNeeded() {
  if (!webToolsReadyPromise) {
    webToolsReadyPromise = new Promise((resolve) => {
      const scriptTag = document.createElement('script');
      scriptTag.src = `https://wt.babbel.${getCurrentDomainExtension()}/wt/web-tools.cjs`;
      scriptTag.id = webtoolsScriptId;
      globalThis.addEventListener('web-tools:loaded:marketing-tracker', () => {
        resolve();
      });
      document.head.append(scriptTag);
    });
  }
  return webToolsReadyPromise;
}

export { getScriptStatuses, loadWebToolsModuleIfNeeded };
